import { render, staticRenderFns } from "./RemoteListagem.vue?vue&type=template&id=15438eda&"
import script from "./RemoteListagem.vue?vue&type=script&lang=js&"
export * from "./RemoteListagem.vue?vue&type=script&lang=js&"
import style0 from "./RemoteListagem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports